// extracted by mini-css-extract-plugin
module.exports = {"dialog":"live-conversations__Modal__dialog","dialogHeader":"live-conversations__Modal__dialogHeader","dialogFooter":"live-conversations__Modal__dialogFooter"};